import { IMPORTER_TRANSACTIONS_QUEUE } from "@common/helpers/financialDocument";
import { PREMIUM_FEATURES } from "@common/flatRateBilling";
import { useAllowFeature } from "@hooks/useAllowFeature";
import { useOverlays } from "contexts/OverlayContext";
import {
    StandardModal,
    StandardModalBody,
    StandardModalHeader,
} from "@design-system/Modal/Modal";
import { ImporterContextProvider } from "./ImporterContextProvider";
import { Importer } from "./Importer";

export const ImporterModal: React.FC = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const { hasAccess, isFetched } = useAllowFeature(PREMIUM_FEATURES.IMPORTER);
    const overlayInfo = getOverlayInfo("importer");
    if (!overlayInfo?.data || !isFetched || !hasAccess) {
        return null;
    }

    return (
        <StandardModal
            fullscreen
            onHide={closeOverlay}
            show={!overlayIsClosing}
        >
            <StandardModalHeader>
                <div>Import transactions</div>
            </StandardModalHeader>
            <StandardModalBody>
                <ImporterContextProvider
                    importerQueue={IMPORTER_TRANSACTIONS_QUEUE}
                    readyToImportLabel="Ready to import"
                >
                    <Importer onHide={closeOverlay} />
                </ImporterContextProvider>
            </StandardModalBody>
        </StandardModal>
    );
};
